import React, { Component } from "react";
import Logo from "../../images/logo.png";
class Signup_header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="header">
      {!window.opener ?
        <a href="/" className="logosec">
          <img src={Logo} alt="v" />
        </a> : <a className="logosec">
                    <img src={Logo} alt=""/>
                </a>}
     {!window.opener ?
        <a className="btn" href="">
          How it Works?
        </a> : null}
      </div>
    );
  }
}
export default Signup_header;
